let baseChecklistBoiler = {
    IncidentChecklistBaseId: null,
    WorkCompIncidentTypeId: null,
    ChecklistText: null,
    Phone: null,
    Email: null,
    DocumentLink: null,
    InfoText: null,
    CreatedDateUtc: null,
    CreatedBy: null,
    ModifyDateUtc: null,
    ModifiedBy: null,
    DeletedDateUtc: null,
    DeletedBy: null,
    DisabledDateUtc: null,
    DisabledBy: null
}
export default baseChecklistBoiler